import React from "react";
import {css} from "@emotion/react";

import {PanelExpandable} from "@pg-design/expandable-module";
import {Text} from "@pg-design/text-module";

export interface IProps {
    children: React.ReactNode;
    title: string;
    open?: boolean;
    className?: string;
}

export const OfferLocationLinksList: React.FC<IProps> = (props) => {
    return (
        <PanelExpandable
            title={
                <Text as="h4" variant="headline_6">
                    {props.title}
                </Text>
            }
            alwaysOpen
        >
            <ul css={linksGroupUl}>{props.children}</ul>
        </PanelExpandable>
    );
};

const linksGroupUl = css`
    list-style: none;
    margin: 0;
    padding: 0;
`;
